import { BaseService } from 'services/baseService';
import { CurrencyModel } from 'types/models/CurrencyModel';

class CurrencyService extends BaseService<CurrencyModel> {
  controllerName = 'currency';
}

export const currencyService = new CurrencyService();
